// extracted by mini-css-extract-plugin
export default {"upsellWrapper":"xO","backgroundimage":"yO","header":"zO","headerwrap":"AO","title":"BO","promomessage":"CO","upsellItem":"EO","upsellImg":"FO","helperText":"GO","upsellHeadline":"HO","price":"IO","upsellGross":"JO","upsellNet":"KO","upsellButton":"LO","nutritionfacts":"MO","nutritionimg":"NO","containerwhy":"OO","nutritionwrappwer":"PO","headlinewhy":"QO","boxwhy":"RO","textwhy":"SO","backbutton":"TO","drawercontainer":"UO","logoheader":"VO","textwrap":"WO","timer":"XO"};
    if(module.hot) {
      // 1713211525622
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  